// extracted by mini-css-extract-plugin
module.exports = {"selectedCall":"LecturerSearchBar_selectedCall__3FoLM","pillLabel":"LecturerSearchBar_pillLabel__2KEkA","spin360":"LecturerSearchBar_spin360__3rAa6"};